import React from 'react';
import '../../scss/components/header.scss';

function Header() {
  return (
        <header className='header'>
        <div className="header__logo">
          <a href="#">
              <img src="/images/header/logo.png" alt="void gods" />
          </a>
        </div>
        <div className="header__info">
            <div className="header__socials">
              <a href="#">
              <img src="/icons/twitter.png" alt="twitter" className="twitter" />
              </a>
              <a href="#">
                <img src="/icons/discord.png" alt="discord" className="" />
              </a>
            </div>
            <button className="header__list-btn">
                White list
            </button>
        </div>
    </header>

  )
}

export default Header